export default class MotorsInventoryView
{
	ownerId = null
	type = null
	motors = []

	get totalPropWeight()
	{
		return Math.ceil(this.motors.map(m => m.propWeight * m.quantity).reduce((p, c) => p + c, 0));
	}

	get totalImpulse()
	{
		return Math.ceil(this.motors.map(m => m.totalImpulse * m.quantity).reduce((p, c) => p + c, 0));
	}

	findMotor(motorId)
	{
		return this.motors.find(m => m.motorId == motorId)
	}

	upsertMotor(motor, quantity, notes)
	{
		let m = this.findMotor(motor.motorId);
		if(m)
		{
			m.quantity = quantity;
			m.notes = notes;
		}
		else
		{
			let m = new MotorsInventoryView.Motor();
			m.motorId = motor.motorId;
			m.manufacturer = motor.manufacturer;
			m.designation = motor.designation;
			m.name = motor.name;
			m.classification = motor.classification;
			m.totalImpulse = motor.totalImpulse;
			m.delay = motor.delay;
			m.diameter = motor.diameter;
			m.length = motor.length
			m.type = motor.type;
			m.casing = motor.casing;
			m.propWeight = motor.propWeight;
			m.propType = motor.propType
			m.quantity = quantity;
			m.notes = notes;

			this.motors.push(m)
		}
	}

	updateMotor(motorId, quantity, notes)
	{
		let m = this.findMotor(motorId)
		m.quantity = quantity;
		m.notes = notes;
	}

	updateQuantity(motorId, delta)
	{
		let m = this.findMotor(motorId)
		if(!m)
			return null;

		m.quantity += delta;
		
		return m;
	}

	deleteMotor(motorId)
	{
		let index = this.motors.findIndex(m => m.motorId == motorId)
		if(index == -1)
			return;
		
		this.motors.splice(index, 1);
	}

	static Motor = class {
		motorId = null;

		manufacturer = null
		
		designation = null
		name = null

		classification = null
		totalImpulse = null
		delay = null

		diameter = null
		length = null

		type = null
		casing = null

		propWeight = null
		propType = null

		quantity = 0
		notes = null
	}
}